import stringComparison from 'string-comparison';

export function findCloseMatchAndSort(str: string, arr: string[]): { member: string; rating: number }[] {
    return stringComparison.levenshtein.sortMatch(str, arr).sort((a, b) => b.rating - a.rating)
}